import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { VituInputComponent } from "./vitu-input.component";
import { FormsModule } from "@angular/forms";

@NgModule({
    declarations: [
        VituInputComponent
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        VituInputComponent
    ]
})
export class VituInputModule { }
